import { Injectable } from '@angular/core';
import { BullhornDataSourceApiService, BullhornNamespace, SalesforceDataSourceApiService, SalesforceNamespace } from 'datasource-service-lib';
import { InveniasDataSourceApiService, InveniasNamespace } from 'datasource-service-lib';
import { BullhornEntityMetadataService } from 'entity-metadata-service-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { BullhornEntitySelectDialogService } from './bullhorn.entityselectdialog.service';
import { IEntitySelectDialogService } from './ientityselectdialogservice';
import { InveniasEntitySelectDialogService } from './invenias.entityselectdialog.service';
import { SalesforceEntitySelectDialogService } from './salesforce.entityselectdialog.service';

@Injectable({ providedIn: 'root' })
export class EntitySelectionDialogServiceFactory {
  constructor(private sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory) {}

  create(namespace: string): IEntitySelectDialogService {
    if (namespace === InveniasNamespace.name) {
      const serviceProvider = this.sharedServiceProviderServiceFactory.getServiceProviderService(namespace);
      const inveniasDataSourceApiService = <InveniasDataSourceApiService> serviceProvider.getDataSourceApiService();
      return new InveniasEntitySelectDialogService(inveniasDataSourceApiService);
    }

    if (namespace === BullhornNamespace.name) {
      const serviceProvider = this.sharedServiceProviderServiceFactory.getServiceProviderService(namespace);
      const bullhornDataSourceService = <BullhornDataSourceApiService> serviceProvider.getDataSourceApiService();
      const metaService = <BullhornEntityMetadataService> serviceProvider.getEntityMetadataService();
      return new BullhornEntitySelectDialogService(bullhornDataSourceService, metaService);
    }

    if (namespace === SalesforceNamespace.name) {
      const serviceProvider = this.sharedServiceProviderServiceFactory.getServiceProviderService(namespace);
      const salesforceDataSourceService = <SalesforceDataSourceApiService> serviceProvider.getDataSourceApiService();
      return new SalesforceEntitySelectDialogService(salesforceDataSourceService);
    }

    throw new Error(`Unexpected namespace '${namespace}'`);
  }
}
